$(document).ready(function(){
$(document).on('click',".video_wrapper",function (e) {
 e.preventDefault();

        $(this).addClass("active");
        var v_id = $(this).attr("data-id");
        if(v_id != ''){
            $(".review_video iframe").attr("src", "https://www.youtube.com/embed/" + v_id +"?mute=1&autoplay=1"), $(".review_video").show(), $("body").addClass("custm_active")
        }
})
  
$(document).on('click',".review_video, span .custm_close",function (a) {
        $(".csmt_review_img .image-icon").removeClass("active"),
            $(".review_video iframe").attr("src", "https://www.youtube.com/embed/"),
            $(".review_video").hide(),
            $("body").removeClass("custm_active");
    })
})